/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Button, Col, Row, Space } from 'antd';
import { useDispatch } from 'react-redux';
import { rolePermissionActions } from '@lyra/core';
import { RoleForm } from '@shared-components/forms';
import { RoleTable } from '@shared-components/modules';
import {
  DrawerElem,
  PageHeaderMenu,
  PageHeaderTitle,
} from '@shared-components/elements';
import {
  CANCEL_BTN,
  DRAWER_WIDTH,
  LIST_OF_ROLES,
  PAGE_HEADER_MENU_ROLE,
  VIEW_ROLE,
} from '@moxie/constants';
import { Form } from 'antd';
import { IRolePermission } from '@shared-components/models';

const RoleLists: React.FC = () => {
  const [showDrawerVisible, setShowDrawerVisible] = useState(false);
  const [refreshTable, setRefreshTable] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditId, setIsEditId] = useState<string | number | null | undefined>(
    null
  );
  const [isFieldsDisabled, setIsFieldsDisabled] = useState(true);
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const triggerRefresh = () => setRefreshTable((prev) => !prev);

  const handleAddUpdateRole = (value: {
    name: string;
    description: string;
    id: string | number | null | undefined;
    permissions?: (string | number)[];
  }) => {
    const { name, description, id, ...permissions } = value;
    if (!name) return;
    const permValuesArr: any = Object.values(permissions).filter(
      (item) => item !== undefined
    );
    const permissionsArr = [].concat(...permValuesArr);
    value.permissions = permissionsArr;
    const data: IRolePermission = {
      name: value.name,
      description: value.description,
      permissions: value.permissions,
    };
    if (isEdit) {
      data.id = isEditId;
      dispatch(
        rolePermissionActions.updateRoleRequest({ data, triggerRefresh })
      );
    } else {
      dispatch(rolePermissionActions.addRoleRequest({ data, triggerRefresh }));
    }
    onClose();
  };

  const handleDelete = async (id: string) => {
    dispatch(rolePermissionActions.deleteRoleRequest({ id, triggerRefresh }));
  };

  const onClose = () => {
    setShowDrawerVisible(false);
    setRefreshTable(false);
    setIsEdit(false);
    setIsEditId(null);
    form.resetFields();
    dispatch(rolePermissionActions.clearRolesSuccess());
  };

  const handleEditDrawer = async (id?: string) => {
    return;
    setShowDrawerVisible(true);
    setIsEdit(true);
    setIsEditId(id);
    dispatch(rolePermissionActions.getRoleRequest(id));
  };

  useEffect(() => {
    dispatch(rolePermissionActions.getPermissionsRequest());
    return () => {
      dispatch(rolePermissionActions.clearRolesSuccess());
      form.resetFields();
    };
  }, [dispatch, form]);

  return (
    <>
      <DrawerElem
        title={VIEW_ROLE}
        width={DRAWER_WIDTH}
        onClose={onClose}
        visible={showDrawerVisible}
        footer={
          <div className="text-align-right">
            <Space size={8}>
              <Button onClick={onClose}>{CANCEL_BTN}</Button>
            </Space>
          </div>
        }
      >
        {showDrawerVisible && (
          <RoleForm
            form={form}
            isEdit={isEdit}
            isEditId={isEditId}
            handleSubmit={handleAddUpdateRole}
            isFieldsDisabled={isFieldsDisabled}
            hideAction
          />
        )}
      </DrawerElem>
      <PageHeaderTitle title={LIST_OF_ROLES} />
      <PageHeaderMenu menu={PAGE_HEADER_MENU_ROLE}></PageHeaderMenu>
      <Row>
        <Col span={24} className="padding-top-2">
          <RoleTable
            showDrawer={handleEditDrawer}
            setRefreshTable={setRefreshTable}
            refreshTable={refreshTable}
            handleDelete={handleDelete}
            setIsFieldsDisabled={setIsFieldsDisabled}
          />
        </Col>
      </Row>
    </>
  );
};

export default RoleLists;
